module.exports = __webpack_public_path__ + "img/ios-restaurant.7bc0d43c.svg";